/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fee: NonNullable<unknown> }} Pricing_Feature_Zero_FeesInputs */

const en_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% Platform Fee`)
};

const es_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% Comisión de plataforma`)
};

const fr_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee} % de frais de plateforme`)
};

const de_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% Plattformgebühr`)
};

const ja_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プラットフォーム手数料${i?.fee}%`)
};

const zh_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% 平台费`)
};

const ar_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`رسوم منصة ${i?.fee}%`)
};

const id_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Biaya Platform ${i?.fee}%`)
};

const it_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commissione di Piattaforma ${i?.fee}%`)
};

const ru_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Комиссия платформы ${i?.fee}%`)
};

const pt_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% de Taxa de Plataforma`)
};

const ko_pricing_feature_zero_fees = /** @type {(inputs: Pricing_Feature_Zero_FeesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.fee}% 플랫폼 수수료`)
};

/**
* | output |
* | --- |
* | "{fee}% Platform Fee" |
*
* @param {Pricing_Feature_Zero_FeesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_zero_fees = /** @type {((inputs: Pricing_Feature_Zero_FeesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Zero_FeesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_feature_zero_fees(inputs)
	if (locale === "es") return es_pricing_feature_zero_fees(inputs)
	if (locale === "fr") return fr_pricing_feature_zero_fees(inputs)
	if (locale === "de") return de_pricing_feature_zero_fees(inputs)
	if (locale === "ja") return ja_pricing_feature_zero_fees(inputs)
	if (locale === "zh") return zh_pricing_feature_zero_fees(inputs)
	if (locale === "ar") return ar_pricing_feature_zero_fees(inputs)
	if (locale === "id") return id_pricing_feature_zero_fees(inputs)
	if (locale === "it") return it_pricing_feature_zero_fees(inputs)
	if (locale === "ru") return ru_pricing_feature_zero_fees(inputs)
	if (locale === "pt") return pt_pricing_feature_zero_fees(inputs)
	return ko_pricing_feature_zero_fees(inputs)
});